import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Hero from './components/Hero';
import About from './components/About';
import Includes from './components/Includes';
import Steps from './components/Steps';
import Notebook from './components/Notebook';
import Course from './components/Course';
import Community from './components/Community';
import Author from './components/Author';
import FinalMessage from './components/FinalMessage';
import RegistrationForm from './components/RegistrationForm';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="bg-dark-900 text-warm-100">
      <Hero />
      <About />
      <Includes />
      <Steps />
      <Notebook />
      <Course />
      <Community />
      <Author />
      <FinalMessage />
      <RegistrationForm />
      <Footer />
    </div>
  );
}